import Table from 'src/components/atoms/table/table';

export const EmployeesTableHeader = () => {
  return (
    <Table.Row>
      <Table.HeaderCell>Dipendente</Table.HeaderCell>
      <Table.HeaderCell>Email</Table.HeaderCell>
      <Table.HeaderCell>Mansione</Table.HeaderCell>
      <Table.HeaderCell>Stato</Table.HeaderCell>
      <Table.HeaderCell></Table.HeaderCell>
      <Table.HeaderCell></Table.HeaderCell>
    </Table.Row>
  );
};
